<pr-invoice-line-item-display [lineItem]="lineItem">
  <ng-content select="pr-treatment-provider"></ng-content>
</pr-invoice-line-item-display>
<div class="items">
  <ng-content></ng-content>
</div>
